import { render, staticRenderFns } from "./ConformidadeSocioambientalParaguai.vue?vue&type=template&id=209b9a53&lang=pug"
import script from "./ConformidadeSocioambientalParaguai.vue?vue&type=script&lang=js"
export * from "./ConformidadeSocioambientalParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports